import React, { Component } from 'react';
// import { withRouter } from 'react-router-dom';
//import { connect } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import axios from 'axios';
import { apiUrl, carImageUrl, currency, dummycarUrl,categoryURL} from'../Config/Config';
// import Geocode from "react-geocode";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { useState } from "react";
import { Button } from 'react-bootstrap';

		const withRouter = WrappedComponent => props => {
			const params = useParams();
			const  navigate = useNavigate();
			// etc... other react-router-dom v6 hooks
		  
			return (
			  <WrappedComponent
				{...props}
				params={params}
				navigate ={navigate}
				// etc...
			  />
			);
		  };
	
class Add extends Component {

	constructor(props)
	{
		// CheckAuth();
		super();	
		this.state = {			
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'active',
			selSubmenuOption:'',
			selSubmenuValue:'',
			selSubmenuFunc:'',
			selSubmenuLabel:'',	
			loggedInChecked:false,	
			loggedSt:'Both',	
			accessType:'Both',		

			submenuName: '',
			priority: '',
			image_preview:'',
			image_name:'',
			image:'',
			fileExtension: '',
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleOptionChange = this.handleOptionChange.bind(this);
    }
	componentDidMount() {
	}
	  
	handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
   	};
	handleOptionChange = selSubmenuOption => {
        this.setState({selSubmenuOption})
        this.setState({  selSubmenuLabel : selSubmenuOption.label, selSubmenuValue : selSubmenuOption.value, selSubmenuFunc : selSubmenuOption.func});
   	};

	handleInputChange(event) {
		const {name, value} = event.target;      
		this.setState({
			[name]: value
		});
		// if(name === 'loggedIn'){
		// 	this.setState({loggedInChecked: !this.state.loggedInChecked});
		// }	
	}
	handleClickSelecetCategory = (event) => {
		const selectedIndex = event.target.options.selectedIndex;
		var keys = event.target.options[selectedIndex].getAttribute('data-key');
		this.setState({
				specialist_name: keys,	
		});
	}

  	handleSubmit = () => {
		if(this.validateForm()){
			const formdata = this.state;
			var qs = require('qs');
			var status = '';

			const config = {
				headers: {
					'content-type': 'multipart/form-data'
				}
			}

			if(formdata.selectedvalue === ''){
				status =formdata.selectedOption.value;
			}else{
				status = formdata.selectedvalue;
			}

			var postObject ={
				admin_id: localStorage.getItem('admin_id'),
				name : formdata.submenuName,
				priority : formdata.priority,
				slug : formdata.selSubmenuValue,
				funcName : formdata.selSubmenuFunc,
				loggedInChecked : formdata.loggedSt,
				accessType : formdata.accessType,
				image : formdata.image,
				status: status
			}

			let formData = new FormData();
			for(let k in postObject) {
				formData.append(k, postObject[k]);
			}
			axios.post(apiUrl+"submenumanagement/add",formData,config).then(res => {
				if(res.data.status === "success"){
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					setTimeout(
					function() {
						$('.success_message').html(this.props.navigate('/menumanagement'));
					}
					.bind(this),
					3000
					);
				}else{
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					
					setTimeout(
					function() {
						$('.success_message').html('');
					}
					.bind(this),
					3000
					);
				}
			});	
		}
  	}

  validateForm() {
	const {selSubmenuValue} = this.state;

	let errors = {};
	  let formIsValid = true;
	  if(!selSubmenuValue){
		formIsValid = false;
		$('.errorselSubmenuValue').html('<span class="errorspan">Please fill the field</span>');
	}else{
		
		$('.errorselSubmenuValue').html('');
	}
	this.setState({
		errors: errors
	});
	return formIsValid;
}
onChangeHandler=event=>{
	let reader = new FileReader();
	const file = event.target.files[0];
	const extension = file.name.split('.').pop();
	reader.onloadend = () => {
		this.setState({
		image_name: file.name,
		image_preview: reader.result,
		image: file,
		fileExtension:extension,
		
		});
	};
	reader.readAsDataURL(file);
}



  render() {

	const {selectedOption, selSubmenuOption} = this.state;
	var	preview = <img className="img_class" src={this.state.image_preview} alt="" />;


	var current = this;	

    return (
		<div className="wrapper"> 
	
		<Header />
		<MenuSidebar currentpage="menumanagement" />  

		<div id="location-error"></div>
			<div className="content">	
				<div className="content-wrapper">
					<div class="content-wrapper-before"></div>
					<div className="form-wrapper leaa-admin-head card">
						<div className="success_message"></div>
						<div className="title">
							<h4>Add menu</h4>				
						</div>
						<form className="edit"  onSubmit={ e => { this.handleSubmit(this); e.preventDefault(); }}>
							<div className="form-row">
								<div className="form-left">
									<div className="form-group">
										<label>Menu Name<span class="required" style={{ color: "red" }} >* </span> : </label>
										<input type="text" name="submenuName" onChange={this.handleInputChange} className="form-control" value={this.state.submenuName}/>
										<div className="errorsubmenuName"></div>
									</div>
									<div className="form-group">
										<label>Link to<span class="required" style={{ color: "red" }} > * </span> :</label>
										<Select 
										name="status"
										value={selSubmenuOption?selSubmenuOption:{ value: '', label: 'Select'}}
										options={lang.common.submenu_option} 
										isSearchable = {false}
										onChange={this.handleOptionChange}
										/>
										<div className="errorselSubmenuValue"></div>
									</div>
									<div className="form-group" style={{ marginTop: '20px' }}>
										<label>User Access :</label>

										<input onChange={this.handleInputChange} type="radio" name="loggedSt" value="Guest" checked={(this.state.loggedSt == "Guest" ? "checked" : "" )}/>
										Guest
										<input onChange={this.handleInputChange} type="radio"  name="loggedSt" value="Logged In" checked={(this.state.loggedSt == "Logged In" ? "checked" : "" )}/>
										Logged In
										<input onChange={this.handleInputChange} type="radio"  name="loggedSt" value="Both" checked={(this.state.loggedSt == "Both" ? "checked" : "" )}/>
										Both								
									</div>
									<div className="form-group" style={{ marginTop: '20px' }}>										
										<label>Access Type :</label>

										<input onChange={this.handleInputChange} type="radio" name="accessType" value="Normal" checked={(this.state.accessType == "Normal" ? "checked" : "" )}/>
										Normal
										<input onChange={this.handleInputChange} type="radio"  name="accessType" value="AI" checked={(this.state.accessType == "AI" ? "checked" : "" )}/>
										AI Widget
										<input onChange={this.handleInputChange} type="radio"  name="accessType" value="Both" checked={(this.state.accessType == "Both" ? "checked" : "" )}/>
										Both	
									</div> 
								</div>
								
								<div className="form-right">
									<div className="form-group">
										<label>Priority: </label>
										<input type="text" name="priority" onChange={this.handleInputChange} className="form-control" value={this.state.priority}/>
										<div className="errorpriority"></div>
									</div>
									
									<div className="form-group">
										<div className="form-group">					
											<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
											<Select 
											name="status"
											value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
											options={lang.common.status_option} 
											isSearchable = {false}
											onChange={this.handleChange}
											/>
										</div> 
									</div>	
									<div className="form-group">
										<label>Image (jpeg,jpg,png,svg)<span class="required" style={{ color: "red" }} >* </span></label>
										<div className="choose-file">
											{this.state.isHidden && <div className="image_success"></div>}
											<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
										</div>
										{preview}
										{/* {image_preview?<a href="javascript:void(0);">X</a>:''} */}
										<div className="errorfile"></div>  
									</div> 
									
								</div>									
							</div>
							<div className="btn-group export">	
								<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" >Submit</button>
							
							</div>
						</form>
					</div>
				</div>	
			</div>
		</div>
    );
  }
}


export default (withRouter(Add));